/**
  * Definiert den Animationsablauf in der Timeline und bei Benutzer-Interaktionen
  * @namespace v3sWbtPlayerApp:animation
  */

/**
 * Direktive zum Einlesen der Aktionen
 * @class directive_v3sAction
 * @memberOf v3sWbtPlayerApp:animation
 * @param {string} v3s-event - Event (click, mouseover, mouseout)
 * @param {string} v3s-actor - Objekt, welches auf den Event horcht
 * @param {string} v3s-command - Animations-Befehl (show, move)
 * @param {string} v3s-object - Zielobjekt, welches animiert wird
 * @param {string} v3s-duration - Dauer der Animation in Sekunden
 * @param {string} v3s-delay - Verzögerung in Sekunden
 * @param {string} v3s-ease - Animationsgeschwindigkeit
 * @param {string} v3s-x - Bewegung nach rechts ("50": absolut, "+=50": relativ)
 * @param {string} v3s-y - Bewegung nach oben ("50": absolut, "+=50": relativ)
 * @param {string} v3s-effect - Effekt (clip, drop, slide, fade)
 * @param {string} v3s-direction - Animationsrichtung
 * @param {string} v3s-text - Text der Email (Action:"mailpage")
 * @param {string} v3s-subject - Betreff der Email (Action:"mailpage")
 * @param {string} v3s-address - Betreff der Email (Action:"mailpage")
 * @param {string} v3s-format - Das gewünschte Format beim Druck des Zertifikates
 * @param {string} v3s-evaluation-type - Soll die Aufgabe komplett ausgewertet werden, oder nur der aktuelle Versuch? (action: "evaluate")
 * @example
 * Jetzt: <v3s-action v3s-event="click" v3s-actor="T01" v3s-command="show" v3s-object="L01" v3s-duration="2" v3s-effect="bounce"/>
 * Soll:  <v3s-action v3s-event="click" v3s-actor="T01" v3s-command="show" v3s-object="L01" v3s-duration="2" v3s-effect="drop" v3s-ease="bounce" v3s-direction="top"/>
 */
angular.module('v3sWbtPlayerApp').directive('v3sAction', ["v3sInteractionService", function (v3sInteractionService) {
    return {
        restrict: 'E',
        require: '?^v3sPeriod',
        scope: {
            v3sEvent: "@",
            v3sActor: "@",
            v3sItem: "@",
            v3sProperty: "@",
            v3sCommand: "@",
            v3sObject: "@",
            v3sDuration: "@",
            v3sDelay: "@",
            v3sEase: "@",
            v3sX: "@",
            v3sY: "@",
            v3sPath: "@",
            v3sBezier: "@",
            v3sAutoRotate: "@",
            v3sRotation: "@",
            v3sRotationX: "@",
            v3sRotationY: "@",
            v3sScaleX: "@",
            v3sScaleY: "@",
            v3sEffect: "@",
            v3sDirection: "@",
            v3sHref: "@",
            v3sText: "@",
            v3sSubject: "@",
            v3sAddress: "@",
            v3sFormat: "@",
            v3sFilename: "@",
            v3sEntry: "@",
            v3sTime: "@",
            v3sMaxTime: "@",
            v3sEvaluationType: "@"
        },
        link: function (scope, element, attrs, v3sPeriodCtrl) {

            var action = {
                actor: scope.v3sActor,
                command: scope.v3sCommand,
                object: scope.v3sObject
            };

            var parseNumber = function (str, defaultNumber, checkTimeInMs) {
                var result = parseFloat(str);
                if (isNaN(result)) {
                    result = defaultNumber;
                } else if (!!checkTimeInMs && !!str && str.indexOf(".") == -1) { // 8.0 Format (in ms)
                    result /= 1000;
                }
                return result;
            }

            action.duration = parseNumber(scope.v3sDuration, 1);

            action.delay = parseNumber(scope.v3sDelay, 0, true);
            action.time = parseNumber(scope.v3sTime, 0, true);
            action.maxTime = parseNumber(scope.v3sMaxTime, 0, true);

            action.ease = !!scope.v3sEase ? scope.v3sEase : "";

            //TODO Migration

            if (!!scope.v3sEvent) {
                if (scope.v3sEvent == "mouseover") {
                    action.event = "mouseenter";
                } else if (scope.v3sEvent == "mouseout") {
                    action.event = "mouseleave";
                } else {
                    action.event = "click";
                }
            }

            if (!!scope.v3sEffect) {

                if (scope.v3sEffect.indexOf("left") > -1) {
                    action.direction = "left";
                } else if (scope.v3sEffect.indexOf("right") > -1) {
                    action.direction = "right";
                } else if (scope.v3sEffect.indexOf("top") > -1) {
                    action.direction = "top";
                } else {
                    action.direction = "bottom";
                }

                if (scope.v3sEffect.indexOf("blind") > -1) {
                    if (scope.v3sEffect.indexOf("horizontal") > -1) {
                        action.direction = "left";
                    }
                    action.effect = "clip";
                } else if (scope.v3sEffect.indexOf("bounce") > -1) {
                    action.effect = "drop";
                    action.ease = "bounce";
                } else if (scope.v3sEffect.indexOf("drop") > -1) {
                    action.effect = "drop";
                } else if (scope.v3sEffect.indexOf("slide") > -1) {
                    action.effect = "slide";
                } else if (scope.v3sEffect.indexOf("crop") > -1) {
                    action.effect = "clip";
                    action.direction = "center";
                } else if (scope.v3sEffect.indexOf("clip horizontal") > -1) {
                    action.effect = "slideCenter";
                    action.direction = "right";
                } else if (scope.v3sEffect.indexOf("clip vertical") > -1) {
                    action.effect = "slideCenter";
                    action.direction = "top";
                } else if (scope.v3sEffect.indexOf("explode") > -1) {
                    action.effect = "scale";
                    action.ease = "bounce";
                } else {
                    action.effect = scope.v3sEffect;
                }
            }

            if(!!scope.v3sX || !!scope.v3sY){
                action.x = !!scope.v3sX ? scope.v3sX : "+=0";
                action.y = !!scope.v3sY ? scope.v3sY : "+=0";
            }

            if (!!scope.v3sAutoRotate) {
                action.rotation = !!scope.v3sRotation ? scope.v3sRotation : "+=0";
                action.rotationX = !!scope.v3sRotationX ? scope.v3sRotationX : "+=0";
                action.rotationY = !!scope.v3sRotationY ? scope.v3sRotationY : "+=0";
            }

            if (!!scope.v3sRotation || !!scope.v3sRotationX || !!scope.v3sRotationY) {
                action.rotation = !!scope.v3sRotation ? scope.v3sRotation : "+=0";
                action.rotationX = !!scope.v3sRotationX ? scope.v3sRotationX : "+=0";
                action.rotationY = !!scope.v3sRotationY ? scope.v3sRotationY : "+=0";
            }

            if (!!scope.v3sScaleX || !!scope.v3sScaleY) {
                action.scaleX = !!scope.v3sScaleX ? scope.v3sScaleX : "+=0";
                action.scaleY = !!scope.v3sScaleY ? scope.v3sScaleY : "+=0";
            }

            if (!!scope.v3sPath) {
                action.path = scope.v3sPath;

                if (scope.v3sBezier == "none") {
                    action.bezier = "thru";
                    action.curviness = 0;
                } else if (scope.v3sBezier.indexOf("curviness") == 0) {
                    action.bezier = "thru";
                    action.curviness = parseNumber(scope.v3sBezier.replace(/[^\d\.\-]/g, ""), 0);
                } else {
                    action.bezier = scope.v3sBezier;
                }

                action.autoRotate = !!scope.v3sAutoRotate ? scope.v3sAutoRotate == "on" : false;
            }

            if (scope.v3sHref) {
                action.href = scope.v3sHref;
            }

            if (scope.v3sText) {
                action.text = scope.v3sText;
            }

            if (scope.v3sSubject) {
                action.subject = scope.v3sSubject;
            }

            if (scope.v3sAddress) {
                action.address = scope.v3sAddress;
            }

            if (scope.v3sFormat) {
                action.format = scope.v3sFormat;
            }

            if (scope.v3sFilename) {
                action.filename = scope.v3sFilename;
            }

            if (scope.v3sEntry) {
                action.entry = scope.v3sEntry;
            }

            if (scope.v3sItem) {
                action.items = scope.v3sItem;
            }

            if (scope.v3sProperty) {
                action.property = scope.v3sProperty;
            }

            if (!!scope.v3sEvaluationType) {
                action.evaluationType = scope.v3sEvaluationType;
            }

            if (!!action.actor) {
                v3sInteractionService.addAction(action);
            } else if (!!v3sPeriodCtrl){
                v3sPeriodCtrl.addAction(action);
            }

            // Aktualisieren, wenn Nutzerdaten aktualisiert werden
            scope.$watch("v3sText", function (value) {
                action.text = value;
            });
            scope.$watch("v3sSubject", function (value) {
                action.subject = value;
            });
            scope.$watch("v3sAddress", function (value) {
                action.address = value;
            });
        }
    }
}]);